import { DefaultService } from "@/api/SolarCloudApi";
import { QueryConfig } from "@/lib/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export default function getCatalogQueryOptions() {
  return queryOptions({
    queryKey: ["productCatalog"],
    queryFn: getCatalog,
    staleTime: 1000 * 60 * 60 * 4, // 8 hours
  });
}

async function getCatalog() {
  const response = await DefaultService.productCatalogue();
  return response.collection;
}

type useCatalogOptions = {
  queryConfig?: QueryConfig<typeof getCatalogQueryOptions>;
};

export function useCatalog({ queryConfig }: useCatalogOptions = {}) {
  return useQuery({
    ...getCatalogQueryOptions(),
    ...queryConfig,
  });
}
